// @flow

/**
 * Action type to set the ID of the active modal (or undefined if needs to be hidden).
 */
export const SET_ACTIVE_MODAL_ID = 'SET_ACTIVE_MODAL_ID';
export const SET_MENU_STATUS = 'SET_MENU_STATUS';
export const UNSET_CONFERENCE = 'UNSET_CONFERENCE';
export const SET_CONFERENCE_JOINED = 'SET_CONFERENCE_JOINED';
export const SET_USERS_DATA = 'SET_USERS_DATA';
export const SET_USER_CONNECTION_STATUS = 'SET_USER_CONNECTION_STATUS';
export const HANDLE_WEBJAM_HOME_CLICK = 'HANDLE_WEBJAM_HOME_CLICK';
export const SET_IPADDRESS_VIDEO = 'SET_IPADDRESS_VIDEO';
export const SET_SHOW_HIDE_STATUS_WEBJAM_MENU = 'SET_SHOW_HIDE_STATUS_WEBJAM_MENU';
export const SET_INTERNET_STATUS = 'SET_INTERNET_STATUS';
export const SET_SOCKET_CONNECTION_STATUS = 'SET_SOCKET_CONNECTION_STATUS';
export const SET_DATA = 'SET_DATA';
export const SET_NAME = 'SET_NAME';
export const SET_JOIN_ROOM_MODAL_STATUS = 'SET_JOIN_ROOM_MODAL_STATUS';
export const SET_VIDEO_SCREEN_STATUS = 'SET_VIDEO_SCREEN_STATUS';
export const SET_PROTOCOL = 'SET_PROTOCOL';
export const SET_HOST_DATA = 'SET_HOST_DATA';
export const SET_END_ROOM_DATA = 'SET_END_ROOM_DATA';
export const SHOW_OR_HIDE_ERROR_MODAL = 'SHOW_OR_HIDE_ERROR_MODAL';
export const SHOW_HIDE_MODERATOR_DISCONNECT = 'SHOW_HIDE_MODERATOR_DISCONNECT';
export const SHOW_HIDE_MULTIMODERATOR_DISCONNECT = 'SHOW_HIDE_MULTIMODERATOR_DISCONNECT';
export const CLOSE_VIDEO = 'CLOSE_VIDEO';
export const SET_FCM_TOKEN = 'SET_FCM_TOKEN';
export const SET_DEVICE_LIST_DATA = 'SET_DEVICE_LIST_DATA';
export const Set_VALUE_FOR_AUTOCONNECT = 'Set_VALUE_FOR_AUTOCONNECT';
export const API_GET_IPLIST = 'API_GET_IPLIST';
export const SHOW_API_LOADER = 'SHOW_API_LOADER';
export const HIDE_API_LOADER = 'HIDE_API_LOADER';
export const SET_PUBLIC_IP = 'SET_PUBLIC_IP';
export const SET_METRONOME_STATUS = 'SET_METRONOME_STATUS';
export const SET_BUFFER_STATUS = 'SET_BUFFER_STATUS';
export const SET_LATENCY_STATUS = 'SET_LATENCY_STATUS';
export const SET_RECORDING = 'SET_RECORDING';
export const STOP_RECORDING = 'STOP_RECORDING';
export const GHOST_LIST = 'GHOST_LIST';
export const SET_ROOM_OR_IP = 'SET_ROOM_OR_IP';
export const HOST_TAB_DATA = 'HOST_TAB_DATA';
export const CLICK_MAKE_HOST = 'CLICK_MAKE_HOST';
export const HOST_TAB_RELOAD = 'HOST_TAB_RELOAD';
export const SHOW_BUFFER_LOADER = 'SHOW_BUFFER_LOADER';
export const AUDIO_GHOST = 'AUDIO_GHOST';
export const GHOST_VOICESYNC = 'GHOST_VOICESYNC';
export const CONNECT_AUDIO_GHOST = 'CONNECT_AUDIO_GHOST';
export const SET_HYBRID_SESSION = 'SET_HYBRID_SESSION';
export const SET_LOGIN_MODAL = 'SET_LOGIN_MODAL';
export const SET_USER_IS_LOGIN = 'SET_USER_IS_LOGIN';
export const SET_USER_LOGIN_DATA = 'SET_USER_LOGIN_DATA';
export const SET_ROOM_PASS_PROTECT = 'SET_ROOM_PASS_PROTECT';
export const SET_GHOST_RECORDING = 'SET_GHOST_RECORDING';
export const AUTO_MAKE_HOST = 'AUTO_MAKE_HOST';
export const CLICK_AUTO_MAKE_HOST = 'CLICK_AUTO_MAKE_HOST';
export const SET_WAITING_SCREEN = 'SET_WAITING_SCREEN';
export const SET_CLOSE_AVATAR_POP = 'SET_CLOSE_AVATAR_POP';

export const SET_HOST_REFRESH = 'SET_HOST_REFRESH';
export const SET_HOST_REFRESH_TIMER = 'SET_HOST_REFRESH_TIMER';
export const SET_IS_CLAIM_CLICKED = 'SET_IS_CLAIM_CLICKED';
export const SET_AUDIO_GHOST_CONNECT = 'SET_AUDIO_GHOST_CONNECT';
export const SET_CHAT_RECORDING_FILES = 'SET_CHAT_RECORDING_FILES';
export const SET_CHAT_RECORDING_FILES_VISIBILITY = 'SET_CHAT_RECORDING_FILES_VISIBILITY';
export const SET_LOBBY_STATUS = 'SET_LOBBY_STATUS';

//  Dynnamic tools and functionality
export const SET_APP_URLS = 'SET_APP_URLS';
export const SHOW_TOAST_POPUP = 'SHOW_TOAST_POPUP';
export const SET_STEM_RECORDING = 'SET_STEM_RECORDING';
export const SET_STEM_RECORDING_URL = 'SET_STEM_RECORDING_URL';
export const SET_DELAY_PANNING = 'SET_DELAY_PANNING';
export const SET_PREV_PANNING = 'SET_PREV_PANNING';
export const SET_DEVICES_USERS = 'SET_DEVICES_USERS';
export const SET_HOST_WAIT_INIT = 'SET_HOST_WAIT_INIT';
// export const SET_AUDIO_CHANNEL = 'SET_AUDIO_CHANNEL';

//  Duet dynamic theme 05-may-2022	
export const SET_DECODED_DATA = "SET_DECODED_DATA";
export const SET_AUTH_VERIFY_TOKEN = "SET_AUTH_VERIFY_TOKEN";
// export const SET_ORGANIZATION_LIST = "SET_ORGANIZATION_LIST";
// export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const SET_TEACHER_WILL_WAIT = "SET_TEACHER_WILL_WAIT";
export const SET_STUDENT_MODERATOR = "SET_STUDENT_MODERATOR";
export const SET_ROOM_USERS = "SET_ROOM_USERS";
export const SET_STUDENT_SECOND_MODERATOR = "SET_STUDENT_SECOND_MODERATOR";
// export const SET_RECORDING_TYPE = 'SET_RECORDING_TYPE';

export const SET_THIRD_PARTY_HOST_TAB_DATA = 'SET_THIRD_PARTY_HOST_TAB_DATA';
export const HOST_TAB_DATA_MAIN = 'HOST_TAB_DATA_MAIN';
export const SET_PREJOIN_INFO_CODE = 'SET_PREJOIN_INFO_CODE';
export const SET_IS_LOGOUT = 'SET_IS_LOGOUT';
export const SET_WAITING_SCREEN_STATUS = "SET_WAITING_SCREEN_STATUS";


